import { createFileRoute } from "@tanstack/react-router";

import { BASE_URL, OG_VERSION } from "@/common/links";
import { AffiliatesPage } from "@/landing/components/AffiliatesPage";
import { PAGE_META } from "@/landing/lib/page-meta";

export const Route = createFileRoute("/_landing/affiliates")({
  component: AffiliatesPage,
  head: () => ({
    meta: [
      { title: PAGE_META["/affiliates"].title },
      { name: "description", content: PAGE_META["/affiliates"].description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${BASE_URL}/affiliates` },
      { property: "og:title", content: PAGE_META["/affiliates"].title },
      {
        property: "og:description",
        content: PAGE_META["/affiliates"].description,
      },
      {
        property: "og:image",
        content: `${BASE_URL}/og/affiliates.png?v=${OG_VERSION}`,
      },
      { name: "twitter:title", content: PAGE_META["/affiliates"].title },
      {
        name: "twitter:description",
        content: PAGE_META["/affiliates"].description,
      },
      {
        name: "twitter:image",
        content: `${BASE_URL}/og/affiliates.png?v=${OG_VERSION}`,
      },
    ],
    links: [{ rel: "canonical", href: `${BASE_URL}/affiliates` }],
  }),
});
